import { getCampaigns } from "./campaigns"
import { campaignKeys } from "./queryKeys"
import { useQuery } from "@tanstack/react-query"
import type { ICampaignsRequestParams } from "./types"

export const useGetCampaignsQuery = (params?: ICampaignsRequestParams) => {
  return useQuery({
    queryKey: campaignKeys.campaigns(params),
    queryFn: () => getCampaigns(params),
    select: (data) => {
      return data.sort((a, b) => a.campaign_name.localeCompare(b.campaign_name))
    },
  })
}
